import { lazy } from 'react'
import langConfig from "@configs/langConfig"
const {t} = langConfig

const AccountSettings = [
    {
        path: '/account-settings',
        title : t('Account settings'),
        component: lazy(() => import('../../views/account-settings/')),
    }
]


export default AccountSettings